import React, { FC } from 'react'

const OneCollumAdd:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/one-collum-add.png" alt=''/>
        </div>
    </div>
  )
}

export default OneCollumAdd